module.exports = __webpack_public_path__ + "static/media/Info.17569506.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Info.png
// module id = 509
// module chunks = 4